import React from 'react';
var RightContent = function (props, size, alt) {
  return /*#__PURE__*/React.createElement("img", {
    alt: alt,
    style: {
      width: size,
      height: size
    },
    src: props
  });
};
export default RightContent;